import React from 'react';
import './App.css';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { StatsProvider } from './contexts/StatsContext';
import { Toaster } from './components/ui/sonner';
import CookieBanner from './components/CookieBanner';

// Pages
import HomePage from './pages/HomePage';
import CoursesPage from './pages/CoursesPage';
import AboutPage from './pages/AboutPage';
import BGCoursesPage from './pages/BGCoursesPage';
import ContactPage from './pages/ContactPage';
import ImprintPage from './pages/ImprintPage';
import PrivacyPage from './pages/PrivacyPage';

function App() {
  return (
    <LanguageProvider>
      <StatsProvider>
        <div className="App">
          <HashRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/kurse" element={<CoursesPage />} />
              <Route path="/ueber-uns" element={<AboutPage />} />
              <Route path="/bg-kurse" element={<BGCoursesPage />} />
              <Route path="/kontakt" element={<ContactPage />} />
              <Route path="/impressum" element={<ImprintPage />} />
              <Route path="/datenschutz" element={<PrivacyPage />} />
              {/* English Routes */}
              <Route path="/en" element={<HomePage />} />
              <Route path="/en/courses" element={<CoursesPage />} />
              <Route path="/en/about" element={<AboutPage />} />
              <Route path="/en/bg-courses" element={<BGCoursesPage />} />
              <Route path="/en/contact" element={<ContactPage />} />
            </Routes>
          </HashRouter>
          <Toaster position="top-right" />
          <CookieBanner />
        </div>
      </StatsProvider>
    </LanguageProvider>
  );
}

export default App;
